import { Route } from "react-router-dom";

export const RoutesRenderer = (routArray, CustomRoute) => {
  return routArray.map((RouteObj, index) => {
    const Element=RouteObj.element
    return <Route key={index} element={<CustomRoute key={index} {...RouteObj} />}>
      <Route {...RouteObj} element={<div><Element /></div>} />
    </Route>
  })
};